import type { AnalyticsOnboardingResponse } from '@mygate/common';
import { OnboardingFunnel } from '../OnboardingFunnel';
import { AnalyticsMetric, integer } from './AnalyticsPrimitives';

export function AnalyticsOnboarding({ data }: { data: AnalyticsOnboardingResponse }) {
  return (
    <>
      <div className="analytics-metrics analytics-metrics--three">
        <AnalyticsMetric
          title="Neue Accounts"
          value={integer.format(data.onboarding.cohortSize)}
          note="Im ausgewählten Zeitraum"
          definition="Accounts, die im Zeitraum angelegt wurden. Diese Accounts bilden die Kohorte im Verlauf darunter."
        />
        <AnalyticsMetric
          title="Verrechnungs- & Kryptokonto"
          value={integer.format(data.period.tradevestCompleted)}
          note="Im ausgewählten Zeitraum eingerichtet"
          definition="Accounts mit abgeschlossener Einrichtung des Verrechnungs- und Kryptokontos bei Tradevest. Gezählt nach Abschlussdatum im Zeitraum, unabhängig vom Registrierungsdatum. Ein Wertpapierdepot ist ein zusätzlicher Schritt."
        />
        <AnalyticsMetric
          title="Depots für Aktien & ETFs"
          value={integer.format(data.totals.securitiesDepotsAvailable)}
          note="Aktuell verfügbar · Gesamtbestand"
          definition="Zusätzliche Depots für Aktien und ETFs, die aktuell in der App verfügbar sind. Gezählt werden alle Accounts, unabhängig vom gewählten Zeitraum. Ein verfügbares Depot bedeutet noch keine Einzahlung oder Investition."
        />
      </div>
      <OnboardingFunnel snapshot={data.onboarding} summary={data} />
    </>
  );
}
